module.exports = __webpack_public_path__ + "static/mobile_hero-8cf927aab3e3e7720d0991a047c1f689.jpg";